import React from 'react'
import Userdepartmentlist from '../../components/userdepartmentcomponents/Userdepartmentlist'

function UserDepartmentDetails({renderPageContent}) {
    return (
        <>
             <Userdepartmentlist renderPageContent={renderPageContent}/>
        </>
    )
}

export default UserDepartmentDetails;
